<template>
	<div class="ai_chips">
		<div v-for="(item, qi) in questions" :key="`q${qi}`" class="ai_chips_group">
			<p class="ai_chips_question">{{ item.question }}</p>
			<div class="ai_chips_options">
				<button v-for="(option, oi) in item.options" :key="`q${qi}-o${oi}`"
					type="button" class="ai_chips_option"
					:class="{ 'is-selected': selections[qi] === option }"
					:disabled="disabled" @click="pick(qi, option)">
					{{ option }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
// Chips de clarificación de Phi (fase 17 — docs/PLAN_PHI_CLARIFICACIONES.md).
// Componente de presentación puro: recibe las preguntas del evento SSE
// `question` y emite la respuesta compuesta como TEXTO PLANO (la selección
// viaja como un mensaje normal del usuario; el contrato de /chat no cambia).
// Con una pregunta el click envía directo; con varias, al completar la última.
export default {
	name: "AiQuestionChips",
	props: {
		questions: { type: Array, required: true },
		disabled: { type: Boolean, default: false },
	},
	data() {
		return {
			// Un slot por pregunta, inicializado upfront (reactividad Vue 2:
			// las claves nuevas no son reactivas; se escribe con splice).
			selections: this.questions.map(() => null),
		};
	},
	methods: {
		pick(index, option) {
			if (this.disabled) {
				return;
			}
			this.selections.splice(index, 1, option);
			if (this.selections.every((value) => value !== null)) {
				this.$emit("answer", this.composed());
			}
		},
		composed() {
			if (this.questions.length === 1) {
				return this.selections[0];
			}
			// Con varias preguntas la respuesta repite cada pregunta para
			// que el modelo (y el historial) no tenga que adivinar el orden.
			return this.questions
				.map((item, index) => `${item.question} ${this.selections[index]}`)
				.join(" · ");
		},
	},
};
</script>

<style lang="scss" scoped>
.ai_chips {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-top: 8px;
}

.ai_chips_question {
	margin: 0 0 4px;
	font-size: 12px;
	color: var(--ai-chat-muted);
}

.ai_chips_options {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.ai_chips_option {
	border: 1px solid var(--ai-chat-border);
	background: var(--ai-chat-surface);
	color: var(--ai-chat-ink);
	border-radius: 999px;
	padding: 4px 12px;
	font-size: 12px;
	line-height: 1.4;
	cursor: pointer;
	transition:
		background 0.15s ease,
		border-color 0.15s ease;

	&:hover:not(:disabled) {
		border-color: var(--ai-chat-accent);
		background: var(--ai-chat-accent-soft);
	}

	&.is-selected {
		border-color: var(--ai-chat-accent);
		background: var(--ai-chat-accent);
		color: var(--ai-chat-accent-text);
	}

	&:disabled {
		cursor: default;
		opacity: 0.6;
	}
}
</style>
